'use strict';

import React, { useMemo, useState, useCallback, useRef } from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import Dashboard from '@/Lists/Dashboard'

import ServiceRow from '@/Lists/Rows/ServiceRow'

import SearchBar from '@Pure/SearchBar'
import Link      from '@Pure/Link'

const DASHBOARD = 'ServicesList';

const sortable_columns = ['title'];

const header =
[
	{
		label: 'Titre', name: 'title'
	},
	{
		label: 'Code comptable', name: 'accounting_code'
	},
	{
		label: 'Montant', name: 'amount'
	}
]
.map(opt => ({ ...opt, sortable: sortable_columns.includes(opt.name) }));

const fields = header.map(data => data.name);

const fields_with_timeout = ['searched'];

const storage_filters =
{
	searched: window.localStorage.getItem(DASHBOARD + '.searched') || ''
};

export default PageWrapper(function ServicesDashboardPage (props)
{
	const search_timeout = useRef();

	const [instant_filters, setInstantFilters] = useState({ ...storage_filters });
	const [delayed_filters, setDelayedFilters] = useState({ ...storage_filters });

	const handleChange = useCallback(function ({ value, e, name })
	{
		if (e === null && fields_with_timeout.includes(name) === false) return;

	// Prevent on mount trigger
		if (e === null && fields_with_timeout.includes(name)) return;

		window.localStorage.setItem(DASHBOARD + '.' + name, value);

		setInstantFilters(function (filters)
		{
			return { ...filters, [name]: value };
		});

		if (fields_with_timeout.includes(name) === false) return;

		if (search_timeout.current)
		{
			window.clearTimeout(search_timeout.current);
		}

		search_timeout.current = window.setTimeout(function ()
		{
			search_timeout.current = undefined;

			setDelayedFilters(function (delayed_filters)
			{
				return { ...delayed_filters, [name]: value };
			});
		},
		320);
	},
	[]);

	const handleSearchChange = useCallback(function (value, data={ }, e)
	{
		handleChange({ value: value, name: data?.name, e });
	},
	[handleChange]);

	const filters = useMemo(function ()
	{
		const filters =
		{
			searched: delayed_filters.searched
		};

		return filters;
	},
	[instant_filters, delayed_filters]);

	return (
		<Layout page_title="Gestion des services" history={ props.history }>

			<div className="page-content">

				<div className="o-grid-3 u-flex-wrap u-content-between
					u-margin-bottom-15">

					<div className="o-grid__item">
						<SearchBar hide_btn={ true }
							placeholder="Titre du service"
							handleChange={ handleSearchChange }
							value={ instant_filters.searched }
							name="searched"
							className="c-searchbar c-searchbar--dashboard"
						/>
					</div>

					<div className="o-grid__item" />
				</div>

				<div className="o-content">

					<div className="u-flex u-content-end u-margin-bottom-20">
						<Link href="/gestion-des-services/nouveau"
							className="c-btn c-btn--add u-no-margin-top">
							Nouveau service
						</Link>
					</div>

				</div>

				<div className="o-content">
					<Dashboard model="Service" items-per-page={ 50 }
						url="/dashboard/services" filters={ filters }
						header={ header } fields={ fields }
						order="ASC" order-by="title"
						disable-sort={ filters.searched ? true : false }
						component={ ServiceRow }
					/>
				</div>
			</div>

		</Layout>
	);
});